import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {
  App, Login, Home,Register,Offerings,Resources,SalesTemplates,IoTWGMaterials,IoTFrameworks,
  BMOs,Partners,Offering,Resource,SalesTemplate,IoTWGMaterial,IoTFramework,
  BMO,Partner,FAQ,ContactUs,Search,ErrorPage
} from '../_Views/Containers';
import withTracker from '../common/analytics';



const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path='/login'  component={withTracker(Login, {} )} />
      <Route exact path='/login/:userid/:code' component={withTracker(Login, {} )} />
      <Route exact path='/register' component={withTracker(Register, {} )} />
      <App>
        <Switch>
          <Route exact path='/'  component={withTracker(Home, {} )} />
          <Route exact path='/offerings' component={withTracker(Offerings, {} )}  />
          <Route exact path='/offerings/:slug'  component={withTracker(Offering, {} )} />
          <Route exact path='/news' component={withTracker(Resources,{})} />
          <Route exact path='/news/:slug' component={withTracker(Resource,{})} />

          <Route exact path='/salestemplates' component={withTracker(SalesTemplates,{})} />
          <Route exact path='/salestemplates/:slug' component={withTracker(SalesTemplate,{})} />

          <Route exact path='/iotwgmaterials' component={withTracker(IoTWGMaterials,{})} />
          <Route exact path='/iotwgmaterials/:slug' component={withTracker(IoTWGMaterial,{})} />

          <Route exact path='/iotframeworks' component={withTracker(IoTFrameworks,{})} />
          <Route exact path='/iotframeworks/:slug' component={withTracker(IoTFramework,{})} />

          <Route exact path='/operators' component={withTracker(BMOs,{})} />
          <Route exact path='/operators/:id' component={withTracker(BMO,{})} />
          <Route exact path='/partners' component={withTracker(Partners,{})} />
          <Route exact path='/partners/:id' component={withTracker(Partner,{})} />
          <Route exact path='/faq' component={withTracker(FAQ,{})} />
          <Route exact path='/contact' component={withTracker(ContactUs,{})} />
          <Route exact path='/search' component={withTracker(Search,{})} />
          <Route component={withTracker(ErrorPage,{})} />
        </Switch>
      </App>
    </Switch>
  </BrowserRouter>
)

export default Routes;